<template>
  <div class="app-phone-field">
    <label for="phone-input" class="label-floating">{{ label }}</label>
    <VueTelInput id="phone-input"
                 :model-value="value"
                 :inputOptions="{ placeholder: placeholder, showDialCode: true }"
                 :defaultCountry="defaultCountry"
                 :disabled="disabled"
                 :class="{ 'border-errored': errorMessages.length }"
                 v-bind="$attrs"
                 style="height: 40px;"
    >
    </VueTelInput>
    <div v-for="(errorMessage, index) in errorMessages" :key="index"
         class="text-error text-caption mt-2 ml-2">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
/**
 * A wrapper around vue-tel-input with default styling and custom default behavior
 * @see https://github.com/iamstevendao/vue-tel-input
 */
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

export default {
  name: 'AppPhoneField',
  inheritAttrs: false,
  components: { VueTelInput },
  props: {
    /**
     * @model
     * The input’s value
     */
    value: {
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    /**
     * The input’s placeholder
     * @default ''
     */
    placeholder: {
      default: '',
    },
    /**
     * The input’s default country
     * @default 'FR'
     */
    defaultCountry: {
      default: 'FR',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
  .app-phone-field {
    position: relative;
    
    .label-floating {
      position: absolute;
      top: 0;
      left: 55px;
      padding-left: 3px;
      padding-right: 3px;
      transform: translateY(-50%);
      font-size: 10px;
      color: rgb(var(--v-theme-grey-600));
      background-color: white;
    }

    .border-errored {
      border-color: rgb(var(--v-theme-error));
    }

    .vti__dropdown-list.below {
      top: auto;
      bottom: 100%;
    }
  }
</style>
